<script>
  import ChangeLogsFormatted from "../../../Pages/PatientEncounter/components/ChangeLogsFormatted.svelte";

  import { duplicateIcon } from "../../../Utils/utilConstants.svelte";

  import { copyObjContent } from "../../../Utils/utilFunctions.svelte";

  import { CardLayout } from "../index.svelte";

  export let data = {};

  let changeList = [];

  $: btnOptions = [
    {
      iconName: "copyIcon",
      iFont: duplicateIcon,
      hasTooltip: true,
      tooltip: "Copy content",
      iconFunction: () => copyContent(),
      isHidden: !changeList?.length,
    },
  ];

  const copyContent = () => {
    const copyObj = {};

    changeList.map(
      (data) => (copyObj[data.Field] = `${data.From} => ${data.To}`),
    );

    copyObjContent(copyObj, "Changes Copied!");
  };
</script>

<CardLayout title="Changes" {btnOptions}>
  <div class="p-2">
    <ChangeLogsFormatted row={data} bind:changeList fullWidthDisplay />
  </div>
</CardLayout>
